import { Box, Text } from '@user-portal/wikr-components';
import styled from 'styled-components';

import mediaQueries from 'theme/mediaQueries';
import { color } from 'theme/selectors';

export const Container = styled(Box)`
    display: flex;
    flex-direction: column;
    padding: 32px 16px;
    gap: 16px;
    align-items: center;
    max-width: 432px;
    margin: 0 auto;
`;

export const ModalHeaderTitle = styled.div`
    position: fixed;
    display: flex;
    justify-content: space-between;
    text-align: center;
    align-items: center;
    padding: 16px;
    background: ${color('surface-main')};
    top: 0;
    left: 0;
    width: 100%;
    z-index: 100;
    border-bottom: 1px solid ${color('border-default')};

    ${mediaQueries.laptop} {
        padding: 16px 40px;
    }
`;

export const TitleText = styled.div`
    flex: 1;
    margin-left: 44px;
`;

export const CloseButton = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${color('surface-secondary')};
    height: 44px;
    width: 44px;
    border-radius: 50%;

    &:hover {
        cursor: pointer;
    }
`;

export const TextLink = styled(Text)`
    text-decoration: underline;
`;
